import type { PriceFacts } from "../types";

/**
 * Returns a complete `PriceFacts` object with null defaults for unknown money.
 * Quote/contracts readers typically set `datesKnown: true`.
 */
const createEmptyPriceFacts = (
  overrides: Partial<PriceFacts> = {},
): PriceFacts => ({
  isDiy: false,
  hasVat: false,
  datesKnown: true,
  hourlyRate: null,
  spaceRental: null,
  dayRateDiscount: null,
  dayRateDiscountPercent: null,
  entitlement: null,
  foodDrinkMinimum: null,
  addOnsTotal: null,
  addOns: null,
  additionalPaymentsTotal: null,
  attendeesMin: null,
  attendeesMax: null,
  cleaningFee: null,
  splitPaymentFee: null,
  processingFee: null,
  originalProcessingFee: null,
  taxes: null,
  credits: null,
  bookingTotal: null,
  earningsSubtotal: null,
  hostFee: null,
  estimatedEarnings: null,
  payout: null,
  dueToday: null,
  paidToDate: null,
  priceDifference: null,
  upcomingCharge: null,
  dueAtVenue: null,
  durationHours: null,
  roomType: null,
  foodDrinkType: null,
  upcomingChargeDate: null,
  eventEnd: null,
  bookingStart: null,
  terminalBookingState: null,
  terminalOffsetAmount: null,
  displayBookingTotal: null,
  gratuityAmount: null,
  gratuityRate: null,
  hostPlatformFeeAmount: null,
  hostVatAmount: null,
  guestPaymentAmount: null,
  collectedAtVenueAddOns: null,
  hasPayAtVenueCalculations: false,
  payAtVenueSelected: false,
  isDepositListing: false,
  listingCountry: null,
  isUsListing: false,
  ...overrides,
});

export { createEmptyPriceFacts };
